import Vue from 'vue';
import Router from 'vue-router';
import ServerErrorPage from '@/views/ServerErrorPage';
import SafetyNumbersPage from '@/views/SafetyNumbersPage';
import DataRoamingPage from '@/views/DataRoamingPage';
import AccountHistoryPage from '@/views/AccountHistoryPage';
import IndexLoader from '@/views/IndexLoader';

Vue.use(Router);

const routes = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      component: IndexLoader,
      path: '/',
    },
    {
      component: SafetyNumbersPage,
      path: '/safetynumbers',
    },
    {
      component: AccountHistoryPage,
      path: '/accounthistory',
    },
    {
      component: DataRoamingPage,
      path: '/dataroaming',
    },
    {
      component: ServerErrorPage,
      path: '/error',
    },
    {
      redirect: '/',
      path: '*',
    },
  ],
});
export default routes;
